<div class="flex-col" [ngClass]="{ 'disabled-control': isControlDisabled }">
    <label class="mt-label" *ngIf="label">
        <img
            appImageSelector
            alt="mt-image"
            *ngIf="tooltipDescription?.length"
            imageKey="info"
            imageType="icon"
            placement="right"
            [ngbTooltip]="tooltipDescription"
            class="tooltip-info"
        />
        {{ label }} <span class="required-symbol" *ngIf="requiredField">*</span>
    </label>
    <ng-select
        [placeholder]="placeholder ? placeholder : ('select' | lang)"
        [multiple]="multiselect"
        [searchable]="searchable || items?.length > 6"
        [clearable]="clearable"
        [items]="items"
        [bindLabel]="bindLabel"
        [bindValue]="bindValue"
        [(ngModel)]="_value"
        [disabled]="!items?.length || _disabled || isDisabled"
        (change)="_onChange($event)"
        (focus)="_onTouched($event)"
        class="select-dropdown-panel"
        [closeOnSelect]="closeOnSelect"
        groupBy="selectedAllGroup"
        [selectableGroup]="allSelectedOption ? true : false"
        [selectableGroupAsModel]="false"
    >
        <ng-template *ngIf="treeViewSelect" ng-option-tmp let-item="item">
            <div
                [ngStyle]="{ 'padding-left': (item.level || 0) * 10 + 'px' }"
                [disabled]="item.disabled"
                [class.parent-item]="item.childs && item.childs.length > 0"
                [class.disabled]="item.childs && item.childs.length > 0"
            >
                <input
                    *ngIf="!item.childs || item.childs.length === 0"
                    class="invisible-checkbox"
                    type="checkbox"
                    [checked]="item.selected"
                    (change)="item.selected = !item.selected"
                />
                <span
                    [appTruncateTooltip]="item[bindLabel]"
                    container="body"
                    [class.truncated]="true"
                    [class.parent-item]="item.childs && item.childs.length > 0"
                    [class.bold]="item.childs && item.childs.length > 0"
                >
                    {{ item[bindLabel] }}
                </span>
            </div>
        </ng-template>

        <ng-template
            *ngIf="multiselect && !allSelectedOption"
            ng-optgroup-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
        >
            <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected || []"
            />{{ item | uppercase }}
        </ng-template>

        <ng-template
            *ngIf="multiselect && allSelectedOption"
            ng-optgroup-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
        >
            <input
                id="item-{{ index }}"
                class="mt-input-check"
                type="checkbox"
                [ngModel]="item$.selected"
            />{{ "all-machines" | lang }}
        </ng-template>

        <!-- Select option -->
        <ng-template
            *ngIf="multiselect"
            ng-option-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
        >
            <div class="mt-option flex-row">
                <div [title]="item.description">
                    <img
                        appImageSelector
                        alt="mt-image"
                        *ngIf="
                            image &&
                            item.active &&
                            imagePosition === 'before' &&
                            item[image]
                        "
                        imageType="icon"
                        imageKey="{{ item[image] }}"
                        class="icon-image"
                    />
                    <img
                        appImageSelector
                        alt="mt-image"
                        *ngIf="
                            image &&
                            !item.active &&
                            imagePosition === 'before' &&
                            item[image]
                        "
                        imageType="icon"
                        imageKey="{{ item[image] }}"
                        class="icon-image"
                    />

                    <input
                        id="item-{{ index }}"
                        class="mt-input-check"
                        type="checkbox"
                        [ngModel]="item$.selected"
                    />{{ item[bindLabel] }}
                </div>

                <div
                    class="image-after"
                    *ngIf="imagePosition === 'after' && item[image]"
                >
                    <img
                        appImageSelector
                        alt="mt-image"
                        imageType="icon"
                        [imageKey]="item[image]"
                    />
                </div>
            </div>
        </ng-template>

        <!-- Selected option label on multiselect -->
        <ng-template
            *ngIf="multiselect"
            ng-multi-label-tmp
            let-items="items"
            let-clear="clear"
        >
            <div
                class="ng-value multi-value"
                *ngFor="let item of items | slice : 0 : 1"
            >
                <span class="ng-value-label">{{
                    item[bindLabel].length > 14
                        ? (item[bindLabel] | slice : 0 : 13) + "..."
                        : item[bindLabel]
                }}</span>
                <span
                    class="ng-value-icon right"
                    (click)="clear(item)"
                    aria-hidden="true"
                >
                    <em class="fa fa-times-circle" style="color: #afafaf"></em>
                </span>
            </div>

            <!-- If there is more than 1 option selected, the second one -->
            <div class="ng-value multi-value" *ngIf="items.length > 1">
                <span class="ng-value-label"
                    >{{ items.length - 1 }} {{ "more" | lang }}...</span
                >
            </div>
        </ng-template>

        <!-- Option with image before option -->
        <ng-template
            *ngIf="image && !multiselect"
            ng-label-tmp
            ng-option-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
        >
            <div class="mt-option flex-row">
                <div>
                    <img
                        appImageSelector
                        alt="mt-image"
                        *ngIf="item.active && imagePosition !== 'after'"
                        imageType="icon"
                        imageKey="{{ item[image] }}"
                        class="icon-image"
                    />
                    <img
                        appImageSelector
                        alt="mt-image"
                        *ngIf="!item.active && imagePosition !== 'after'"
                        imageType="icon"
                        imageKey="{{ item[image] }}"
                        class="icon-image"
                    />
                    {{ item[bindLabel] }}
                </div>

                <div
                    class="image-after"
                    *ngIf="imagePosition === 'after' && item[image]"
                >
                    <img
                        appImageSelector
                        alt="mt-image"
                        imageType="icon"
                        [imageKey]="item[image]"
                    />
                </div>
            </div>
        </ng-template>
    </ng-select>
</div>
